import { z } from 'zod';

import { preDefinedOrCustomFilterFieldNameSchema } from './filter-state';

const jobListColumnVisibilitySchema = z.record(z.string(), z.boolean());
const jobRecommendationsFilterSchema = z.record(
    z.string(),
    z.partialRecord(preDefinedOrCustomFilterFieldNameSchema, z.any()),
);
const instructiveTextSchema = z.record(z.string(), z.boolean());

export const gridSortModelSchema = z
    .object({
        field: z.string(),
        sort: z.enum(['asc', 'desc']).nullable(),
    })
    .array();

export const uiSettingsSchema = z
    .object({
        dataAnonymization: z.boolean(),
        dismissedInstructiveText: z
            .string()
            .transform((jsonString) => instructiveTextSchema.catch({}).parse(JSON.parse(jsonString))),
        isFirstLoginPopupShown: z.boolean(),
        jobListColumnOrder: z
            .string()
            .transform((jsonString) => z.string().array().catch([]).parse(JSON.parse(jsonString))),
        jobListColumnSorting: z
            .string()
            .transform((jsonString) => gridSortModelSchema.catch([]).parse(JSON.parse(jsonString))),
        jobListColumnVisibility: z
            .string()
            .transform((jsonString) => jobListColumnVisibilitySchema.catch({}).parse(JSON.parse(jsonString))),
        jobRecommendationsFilter: z
            .string()
            .transform((jsonString) => jobRecommendationsFilterSchema.catch({}).parse(JSON.parse(jsonString))),
        selectedJobArchitectureId: z.uuid().nullable().catch(null),
    })
    .partial();

export type UserUiSettings = z.infer<typeof uiSettingsSchema>;

export type SerializedUiSettings = Record<string, boolean | number | string | null>;
